module.exports = __webpack_public_path__ + "static/media/001-mauritius.40daeee5.svg";